<template>
  <section class="section section--gray">
    <div class="container">
      <div class="section__header section__header--center">
        <span class="section__label">Как это работает</span>
        <h2 class="section__title">От Excel до ведомости — 4 шага</h2>
        <p class="section__subtitle">Так проходит один расчётный период в CandB.pro</p>
      </div>
      <div class="steps">
        <div v-for="(step, i) in steps" :key="i" class="step">
          <div class="step__num">{{ i + 1 }}</div>
          <div class="step__line" v-if="i < steps.length - 1" />
          <div class="step__body">
            <h3 class="step__title">{{ step.title }}</h3>
            <p class="step__text">{{ step.text }}</p>
            <ul class="step__list">
              <li v-for="item in step.items" :key="item">{{ item }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HowItWorksSection',
  data() {
    return {
      steps: [
        {
          title: 'Импорт данных',
          text: 'Кадры из 1С, выработка из учётной системы — обе выгрузки сходятся в одном расчёте.',
          items: ['Оргструктура и сотрудники из 1С', 'Выработка и выручка из учётной системы', 'Excel или ручной ввод'],
        },
        {
          title: 'Формулы в конструкторе',
          text: 'Собираете ваши правила премирования из готовых блоков — без программиста.',
          items: ['Произведение факторов: база × коэффициенты × факт/план', 'Шкалы и ступени', 'Формулы-корректировки (минус) и коэффициенты части'],
        },
        {
          title: 'Расчёт в двух контурах',
          text: 'Сотрудник видит онлайн-оценку премии в любой момент, а сервер считает официальную сумму по всей компании.',
          items: ['Онлайн-оценка сотруднику', 'Авторитетный серверный расчёт', 'Пошаговая расшифровка'],
        },
        {
          title: 'Ведомость в бухгалтерию',
          text: 'Выгружаете готовую расчётную ведомость для начисления зарплаты.',
          items: ['Сводная по сотрудникам', 'Excel/CSV под загрузку в 1С', 'История изменений'],
        },
      ],
    }
  },
}
</script>

<style scoped>
.steps {
  display: flex;
  gap: 0;
  position: relative;
}
.step {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  padding: 0 24px;
}
.step__num {
  width: 56px; height: 56px;
  background: var(--primary);
  color: white;
  border-radius: 50%;
  font-size: 1.375rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}
.step__line {
  position: absolute;
  top: 28px;
  left: calc(50% + 28px);
  right: calc(-50% + 28px);
  height: 2px;
  background: linear-gradient(90deg, var(--primary), #93C5FD);
}
.step__title {
  font-size: 1.125rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--dark);
}
.step__text {
  color: var(--gray);
  font-size: 0.9375rem;
  margin-bottom: 16px;
  line-height: 1.6;
}
.step__list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
}
.step__list li {
  color: var(--gray);
  font-size: 0.875rem;
  padding-left: 20px;
  position: relative;
}
.step__list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: var(--secondary);
  font-weight: 700;
}

@media (max-width: 768px) {
  .steps { flex-direction: column; gap: 40px; }
  .step { align-items: flex-start; text-align: left; padding: 0; flex-direction: row; gap: 20px; }
  .step__line { display: none; }
  .step__num { margin-bottom: 0; }
}
</style>
